// Step 4
// Confirmation Step

import React, { useState, useEffect, useRef } from 'react'
import Product from '../product-component/product';
import { 
  Confirmed,
  CaretUp 
} from '../../common/icons'

import clsx from 'clsx';

import Background from '../../assets/images/confirmation_discovery_membership.png';
import QbrBackground from '../../assets/images/confirmation_qantas_membership_v3.jpg';
import ApiService from "../../services/api.service";
import TagManager from 'react-gtm-module';
import Helper from '../../common/helper';
import {commissionJunctionRules} from "../../common/commission-junction-rules"

export default function ConfirmationStep({selectMembership, isExpress, isQBR, currentStep, termsLink, languages, locationData, stepNo, localStorageDatas, 
  couponObj, isUserLogged, category, businessCategories}) {

  const [input, setInput] = useState({});    
  const [show, setShow] = useState(true)
  const productArr = []

  var getCoupon          = null;
  let PWP                = null;
  productArr.push(localStorageDatas)
  
  function toggleShow() {
    setShow(!show)
  }
  
  if (currentStep !== stepNo) {
    return null
  }
  
  window.sessionStorage.removeItem('selected_membership');
  window.sessionStorage.removeItem('personal_details');
  window.sessionStorage.removeItem('address_details');
  window.sessionStorage.removeItem('secondary_selected_membership');
  window.sessionStorage.removeItem('secondary_personal_details');
  window.sessionStorage.removeItem('secondary_address_details');
  Helper.deleteCookie("coupon");

  var currencyText = "";
  var PrimaryName = localStorageDatas.members[0].first_name;
  var paymentType = localStorageDatas.paymentType;
  var referenceNo = localStorageDatas.transactionId;
  var subscriptionTransaction = localStorageDatas.subscriptionTransaction;
  // var referenceNo = '123456789'
  
  let item_selected = localStorageDatas.members[0].selected_product;

  if(Object.keys(item_selected).length !== 0) {
    if(localStorageDatas && localStorageDatas.members.length > 0 && item_selected && item_selected[0].currency_text) {
      currencyText = item_selected[0].currency_text;
    }

    getCoupon = Helper.checkCoupon(item_selected[0], couponObj);
    PWP       = Helper.newpwpCheck(item_selected[0], isUserLogged, locationData, businessCategories);
  }

  var totalnum = 0;
  var totalGst = 0;

  if(Object.keys(item_selected).length !== 0) {
    for(var i = 0; i < localStorageDatas.members.length; i++) {
      let price = "";
      let gst = "";
      if(localStorageDatas.members[i].selected_product && localStorageDatas.members[i].selected_product[0].purchase_price) {
        price = parseFloat(localStorageDatas.members[i].selected_product[0].purchase_price)
        gst = parseFloat(localStorageDatas.members[i].selected_product[0].tax_amt)
      }
      totalnum += price;
      totalGst += gst
    }
    var totalAmt = totalnum + totalGst;
  }
  var showTotalPrice = (getCoupon.exists || PWP.exists) ? false : true;
  startGtmTransaction();

  async function startGtmTransaction(){
    let ssoUserData = await ApiService.userdata();
    const businessCategory = localStorageDatas.members[0].selected_product[0].business_category_id;

    if(window.dataLayer.filter(a => a.event === 'purchase').length < 1) {
      const transactionPayload = {
        currencyCode: locationData.currency,
        membershipType: ssoUserData ? ssoUserData.card.cardLabel : category,
        paymentMethod: localStorageDatas.paymentType,
        transactionId: localStorageDatas.transactionId,
        transactionTax: "",
        transactionTotal: totalAmt,
        products: productsForGtm(),
        coupon_code: getCoupon.exists ? getCoupon.coupon_code_id : "",
        countryCode: Helper.lookupCurrentCountry().code,
        businessCategory,
        salesType:  commissionJunctionRules(locationData, paymentType),
      };
      
      TagManager.dataLayer(Helper.gtmTransaction(transactionPayload));
    } 
  }

  function productsForGtm() {
    let products = [];
    for(let i=0;i<localStorageDatas.members.length;i++) {
        let member = localStorageDatas.members[i];
        products.push({
            "id": member.selected_product[0].item_group_id,
            "name": member.selected_product[0].item_group_description,
            "price": parseFloat(member.selected_product[0].purchase_price) + parseFloat((member.selected_product[0].tax_amt || member.selected_product[0].tax_amount)),
            "price_no_tax": parseFloat(member.selected_product[0].purchase_price),
            "category": member.selected_product[0].item_group_name,
        });
    }

    return products;
  }

    return(
      <div className='flex justify-evenly align-center'>
        <div className='confirmation-wrapper flex xs:flex-col tablet:flex-row w-full'>
          <div className='holder-confirmation-left xs:flex xs:flex-col xs:items-center'>
            <Confirmed />
            <div className='holder-text py-5 text-xl tracking-tight text-gray-900 dark:text-white font-montsterrat font-semibold xs:text-center'>
              {
                isExpress ? (
                  <p className='font-semibold'>{languages.confirmHi ? languages.confirmHi: 'Hi'} {localStorageDatas.members[0].leah_card_number}, </p>
                ) : (
                  <p className='font-semibold'>{languages.confirmHi ? languages.confirmHi: 'Hi'} {PrimaryName}, </p>
                )
              }              
              <p className='font-semibold'>{languages.confirmPurchase ? languages.confirmPurchase: 'Thanks for your purchase.'}</p>
            </div>
            <div className='holder-receipt pt-3 pb-5'>
              {
                showTotalPrice ? (
                  <div>
                    <div className='receipt-list w-full flex flex-row mb-3'>
                      <p className='title font-gray'>{languages.subTotal ? languages.subTotal: 'Sub Total'}</p>
                      <p className='value ml-auto'>{parseFloat(totalnum).toFixed(2)} <span className='uppercase'>{currencyText}</span></p>
                    </div>
                    <div className='receipt-list w-full flex flex-row'>
                      <p className='title font-gray'>{languages.gst ? languages.gst : 'GST'}</p>
                      <p className='value ml-auto'>{parseFloat(totalGst).toFixed(2)} <span className='uppercase'>{currencyText}</span></p>
                    </div>
                  </div>
                ) : ""
              }
              {/* <div className='lining'></div> */}
              <div className='receipt-list w-full total flex flex-row bordered-receipt'>
                <p className='title font-gray'>{languages.total ? languages.total : 'Total'}</p>
                <p className='value ml-auto'>
                  {PWP.exists && paymentType && paymentType == "Pay with Points" ? (
                    <span className='font-bold'> {PWP.points + ' ALL - Accor Live Limitless Reward points' }</span>
                  ) : (
                    <span className='font-bold'>{(getCoupon.exists ? getCoupon.total + " (coupon applied)" : currencyText + ' ' + parseFloat(totalAmt).toFixed(2))}</span>
                  )}
                   <span className='uppercase'> {PWP.points ? '' : currencyText}</span></p>
              </div>
            </div>
          </div>
          <div className='holder-confirmation-right tablet:ml-5'>
            <div className='holder-reference bg-white p-4'>
              <p className='text-center py-3 font-bold'>{languages.confirmationPaymentRefNo ? languages.confirmationPaymentRefNo : 'Payment reference number #'}{referenceNo}</p>
              <div>
                {/* <p className='text-center py-3'>
                  Auto renew message will be placed here and entered during content entry. With the option to 
                  <a href='' className='text-underline'>
                    opt out here
                  </a> and the 
                  <a href={termsLink} target="_blank" className='text-underline'>
                    T&C’s here.
                    </a>
                </p> */}
                {
                  subscriptionTransaction ?
                  <p className='text-left py-3'>
                  {languages.confirmationConfirmationMessageMembership ? languages.confirmationConfirmationMessageMembership : 'As a member, you enjoy the convenience of your Accor Plus membership being automatically renewed every 12 months.' +
  
                  languages.confirmationConfirmationMessageRenew ? languages.confirmationConfirmationMessageRenew : 'However, if you do not want your Accor Plus membership automatically renewed, you can manage your billing preferences from the payment confirmation email received at the time of your last payment.'}
                  </p> : ''
                }
              </div>
              <div className={clsx('holder-details flex content-center pt-5 flex-col', 
                {
                  'rotated': show
                })}>
                <button
                  onClick={toggleShow}
                  className='font-montsterrat font-semibold text-underline text-green mb-5'
                >{ languages.viewOrderDetails ? languages.viewOrderDetails : 'View order details'} <CaretUp className={'icon-caret'}/></button>
                {
                  show ? (
                    <ul className='details-list'>
                      {/* map products here */}

                      {
                        localStorageDatas.members.map((item, i) => {

                          var totalAmount = parseFloat(item.selected_product[0].purchase_price) + parseFloat(item.selected_product[0].tax_amt)
                          return (
                            <li className='holder-product-reference'>
                              <div className='holder-img'>
                              <img className='' src={isQBR ? QbrBackground : Background}/>
                              </div>
                              <div className='holder-text mt-4'>
                                <div className='holder-text'>
                                  <p className='receipt-text text-l font-montsterrat font-semibold'>                                    
                                    {
                                      item.selected_product[0].item_group_description
                                    }
                                  </p>
                                </div>
                                <div className='holder-text'>                                    
                                  <div className='py-3'>
                                  {PWP.exists && paymentType && paymentType == "Pay with Points" ? (
                                    <span className='font-montsterrat font-medium total-amount'>{PWP.points + ' ALL - Accor Live Limitless Reward points' }</span>
                                  ) : (
                                    <>
                                      {item.selected_product[0].isQbr && (                                        
                                        <div className="mb-3">
                                          {/* <p className='font-montsterrat'>Earn {item.selected_product[0].qbrPoints} Qantas Points with Qantas Business Rewards*</p> */}
                                          {languages.qbrRewardPoints ? (
                                            <p className='font-montsterrat'>{item.selected_product[0].qbrPoints} Qantas Points with Qantas Business Rewards and {languages.qbrRewardPoints} ALL reward points</p>
                                          ) : (
                                            <p className='font-montsterrat'>{item.selected_product[0].qbrPoints} Qantas Points with Qantas Business Rewards*</p>
                                          )}
                                        </div>
                                      )}
                                      <span className='font-montsterrat font-medium total-amount'>{getCoupon.exists === true ? getCoupon.total + " (coupon applied)" : parseFloat(totalAmount).toFixed(2)}</span>
                                      <span className='uppercase'> { ' ' + languages.confirmationYear ? languages.confirmationYear: ' Per Year ' }{ ' ' + currencyText}</span>   
                                    </>                                    
                                  )}
                                    {/* <span>{item.selected_product[i].currency_text} </span> */}
                                  </div>
                                </div>
                                <div className='pb-3'>
                                  <span className='font-montsterrat font-bold'>{ languages.confrimationQuantity ? languages.confrimationQuantity + ' ' : ' QTY ' + ':'}</span>
                                  <span>1</span>
                                </div>
                                {
                                  !isExpress ? (
                                    <div className='list font-montsterrat capitalize'>{item.first_name + ' ' + item.last_name}</div>
                                  ) : ''
                                }
                                
                              </div>
                              <div className='lining-mid'></div>
                            </li>
                          )
                        })
                      }


                    </ul>
                  ) : null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}